import { environment } from "./environment";

export const baseUrl = environment.production
  ? "https://apigw.generali.co.th/api-customer-webform/special-giveaway"
  : "https://apigw-uat.generali.co.th/api-customer-webform/dev/special-giveaway/dev";
